import 'phaser'
import { l } from '../lib/imports'
import { scene } from '../main/scene-sidecar'
import { monsters } from './monsters-sidecar'
import { MonsterType } from './monstersData'

export interface IMonsterSaved {
  type: MonsterType
  i: number
  j: number

  team: number

  maxHitPoints: number
  hitPoints: number

  isCarryingCargo: boolean
  isInsideShip: boolean
  isInSuit: boolean
  isSleeping: boolean

  // stats
  statHunger: number
  statThirst: number
  statToilet: number
  statSocial: number
  statEntertainment: number
  statEnergy: number
  statName: string
}

export function save() {
  let sd: IMonsterSaved[] = []

  let objs = monsters.getAll()
  l.forEach(objs, (c) => {
    sd.push({
      type: c.type,
      i: c.i,
      j: c.j,

      team: c.team,

      maxHitPoints: c.maxHitPoints,
      hitPoints: c.hitPoints,
      isCarryingCargo: c.carryingCargo != null,
      isInsideShip: c.isInsideShip,
      isInSuit: c.isInSuit,
      isSleeping: c.isSleeping,

      statHunger: c.statHunger,
      statThirst: c.statThirst,
      statToilet: c.statToilet,
      statSocial: c.statSocial,
      statEntertainment: c.statEntertainment,
      statEnergy: c.statEnergy,
      statName: c.statName,
    })
  })

  return sd
}

export function load(sd: IMonsterSaved[]) {
  let ctx = scene.getContext()
  l.forEach(sd, (c) => {
    let obj = monsters.create(c.type, c.team || 1)
    monsters.moveToTile(obj, ctx.mapShip, c.i, c.j)

    obj.maxHitPoints = c.maxHitPoints
    obj.hitPoints = c.hitPoints

    obj.isInsideShip = c.isInsideShip
    // obj.isInSuit = c.isInSuit
    monsters.setInSuit(obj, c.isInSuit)
    obj.isSleeping = c.isSleeping

    obj.statHunger = c.statHunger
    obj.statThirst = c.statThirst
    obj.statToilet = c.statToilet
    obj.statSocial = c.statSocial
    obj.statEntertainment = c.statEntertainment
    obj.statEnergy = c.statEnergy
    obj.statName = c.statName

    // obj.isCarryingCargo: c.carryingCargo != null,
    // TODO:! pickup cargo if we were carrying stuff
  })
}
